import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
    container: {
        height: 'calc(100% - 70px)'
    },
    sectionWrapper: {},
    wrapper: {
        height: 'calc(100% - 70px)'
    },
    sectionsWrapper: {
        display: 'flex',
        flexDirection: 'row'
    },
    detailsWrapper: {
        flex: 1
    },
    /* qrCodeWrapper: {
                flex: 1,
                display: 'flex',
                justifyContent: 'center'
            }, */
    input: {
        marginBottom: 16
    },
    rolesTitle: {
        marginBottom: 16,
        fontSize: 18
    },
    picker: {
        marginTop: 15,
        marginBottom: 15
    },
    passwordGenSection: {
        display: 'flex',
        marginBottom: 15
    },
    newPasswordGen: {
        marginRight: 15
    },
    changePasswordSection: {
        marginBottom: 15
    },
    detailsRow: {
        display: 'flex',
        marginBottom: 10,
        alignItems: 'center'
    },
    detailsNameColumn: {
        flex: 1,
        color: theme.quaternary,
        fontWeight: 'bold'
    },
    detailsValueColumn: {
        flex: 1,
        display: 'flex',
        alignItems: 'center'
    },
    detailsInfoWrapper: {
        paddingLeft: 20
    },
    backButton: {
        marginRight: 16
    },
    btnInnerWrapper: {
        display: 'flex',
        alignItems: 'center'
    },
    arrowBackIcon: {
        color: theme.primary
    },
    reportsTable: {
        maxHeight: 'calc(100% - 70px)'
    },
    actionButtons: {
        display: 'flex',
        flex: 1,
        paddingLeft: 8
    },
    actionButton: {
        marginRight: 8
    },
    btnInnerIcon: {
        marginRight: 4,
        fontSize: 20
    },
    resetButton: {
        backgroundColor: theme.warning
    },
    criticalButton: {
        backgroundColor: theme.error
    },
    resetBatteryBtn: {
        marginLeft: 8,
        color: theme.primary,
        padding: 0
    },
    resetBatteryModalBtn: {
        marginRight: 8
    },
    modalButtons: {
        marginTop: 20,
        display: 'flex',
        justifyContent: 'flex-end'
    },
    modalBody: {
        marginTop: 20,
        display: 'flex',
        justifyContent: 'center'
    },
    select: {
        marginBottom: 16
    },
    link: {
        cursor: 'pointer',
        textDecoration: 'none',
        color: theme.primary,
        fontWeight: 'bold'
    },
    deviceStatusText: {
        marginLeft: 8
    },
    catchDescriptionArea: {
        marginTop: 8,
        marginBottom: 8
    },
    catchDescriptionText: {
        marginBottom: 8
    },
    tabs: {
        marginBottom: 16
    },
    picturesWrapper: {
        height: 'calc(100vh - 240px)'
    },
    operationModeIcon: {
        marginRight: 8
    },
    section: {
        marginTop: 16
    },
    imgInstruction: {
        width: 550
    },
    pageTitle: {
        display: 'flex'
    },
    assignedIcon: {
        marginRight: 4
    },
    timeAgo: {
        color: '#FF5656',
        marginLeft: '5px'
    },
    deviceActionButton: {
        [theme.breakpoints.down(980)]: {
            position: 'absolute',
            right: 0,
            top: '-50px'
        }
    },
    reportsAndHistory: {
        display: 'flex',
        gap: 40,
        [theme.breakpoints.down(980)]: {
            flexDirection: 'column'
        }
    },
    // BAIT AND ACTIVITY SECTION
    baitActivitySection: {
        display: 'flex',
        gap: 24,
        width: '100%',
        [theme.breakpoints.down(980)]: {
            flexDirection: 'column'
        }
    }
}))
